import { Col, Form, Row } from "antd";
import React, { useEffect, useState } from "react";
import Selects from "../../../../biblio/Selects/Selects";
import Inputs from "../../../../biblio/Inputs/Inputs";
import SwitchToggle from "../../../../biblio/switch/SwitchToggle";
import UploadInput from "../../../../biblio/Inputs/UploadInput";
import {
  DeleteOutlined,
  PlusCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { convertFileToBase64 } from "../../../../components/utils/utils";
import { reponseQuestion } from "../../../../data/data";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";


interface OrphanHealthStatusProps {
  diseaseType: any;
  healthStates: any;
  disabilityTypes: any;
  form: any;
  index: number;
}

const OrphanHealthStatus = ({
  diseaseType,
  healthStates,
  disabilityTypes,
  form,
  index,
}: OrphanHealthStatusProps) => {
  const [formDisabilities] = Form.useForm();
  const [isDisease, setIsDisease] = useState<boolean>(false);
  const [isHandicapped, setIsHandicapped] = useState<boolean>(false);
  const [disabilities, setDisabilities] = useState<any[]>([]);

  const addDisability = () => {
    setDisabilities([
      ...disabilities,
      {
        disability_type_id: "",
        disability_status: "",
        disability_cause: "",
        attachment_ids: [],
        fileList: [],
      },
    ]);
  };

  // Handle file change and convert to Base64
  const handleFileChange = async (fileList: any[], index: number) => {
    const file = fileList[0]?.originFileObj;
    if (file) {
      try {
        const base64 = await convertFileToBase64(file);
        const imageData = {
          filename: file.name,
          data: base64,
        };

        const updatedBlocks = [...disabilities];
        updatedBlocks[index].attachment_ids = [imageData];
        updatedBlocks[index].fileList = fileList;
        setDisabilities(updatedBlocks);
      } catch (error) {
        console.error("Error converting file to Base64:", error);
      }
    } else {
      const updatedBlocks = [...disabilities];
      updatedBlocks[index].attachment_ids = [];
      updatedBlocks[index].fileList = [];
      setDisabilities(updatedBlocks);
    }
  };

  const updateDisablityCheck = (check: boolean) => {
    setIsHandicapped(check);
    if (check) {
      addDisability();
    } else {
      setDisabilities([]);
    }
  };

  useEffect(() => {
    const l__disabilities = disabilities.map((block, index) => ({
      disability_type_id: block.disability_type_id,
      disability_status: block.disability_status,
      disability_cause: block.disability_cause,
      attachment_ids: block.attachment_ids,
    }));

    form.setFieldValue("disability_type_line_ids" + index, l__disabilities);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabilities]);

  const onChange = (
    value: any,
    key:
      | "disability_type_id"
      | "disability_status"
      | "disability_cause"
      | "attachment_ids",
    index: number
  ) => {
    const l__bloks = [...disabilities];
    if (key === "disability_type_id") {
      l__bloks[index][key] = value.value;
    } else {
      l__bloks[index][key] = value;
    }

    setDisabilities(l__bloks);
  };

  const removeItem = (index: number) => {
    const updatedBlocks = [...disabilities];
    updatedBlocks.splice(index, 1);
    const json: any = {};

    updatedBlocks.forEach((el: any, index: number) => {
      json["disability_type_id" + index] =
        el.disability_type_id !== 0 ? el.disability_type_id : "";
      json["disability_status" + index] = el.disability_status;
      json["disability_cause" + index] = el.disability_cause;
      json["attachment_ids" + index] = el.attachment_ids;
      formDisabilities.setFieldValue(
        "disability_type_id" + index,
        el.disability_type_id !== 0 ? el.disability_type_id : ""
      );
      formDisabilities.setFieldValue(
        "disability_status" + index,
        el.disability_status
      );
      formDisabilities.setFieldValue(
        "disability_cause" + index,
        el.disability_cause
      );
      formDisabilities.setFieldValue(
        "attachment_ids" + index,
        el.attachment_ids
      );
    });
    formDisabilities.resetFields();
    formDisabilities.setFieldsValue(json);
    setDisabilities(updatedBlocks);
  };

  return (
    <>
      <div className="takaful--title-tabs-sub">
        <span>الحالة الصحية</span>
      </div>
      <Row gutter={16} align={"middle"}>
        <Col xxl={6} xl={6} lg={9} md={9} sm={24} xs={24}>
          <Form.Item
            name={`health_state_id${index}`}
            label="الحالة الصحية"
            labelCol={{ className: "takaful--label-style" }}
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
          >
            <Selects options={healthStates?.data} />
          </Form.Item>
        </Col>
        <Col
          style={{ marginTop: "1rem" }}
          xxl={4}
          xl={4}
          lg={5}
          md={5}
          sm={24}
          xs={24}
        >
          <Form.Item name={`is_following_treatment${index}`}>
            <SwitchToggle
              className="takaful--beneficiary-update-switch"
              switchState={isDisease}
              onSwitchChange={() => setIsDisease(!isDisease)}
              label="هل يتابع العلاج؟"
            />
          </Form.Item>
        </Col>
        {!isDisease ? (
          <Col xxl={7} xl={7} lg={9} md={9} sm={24} xs={24}>
            <Form.Item
              name={`not_continuing_treatment_reason${index}`}
              label="سبب عدم متابعة العلاج"
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
        ) : (
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name={`treatment_provider${index}`}
              label="جهة العلاج"
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
        )}
      </Row>

      <Row dir="rtl" gutter={16}>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`disease_type_ids${index}`}
            label="أنواع الأمراض"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Selects
              options={diseaseType}
              mode="multiple"
              className="takaful--select-multiple"
            />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
          <Form.Item name={`is_suffer_from_physical_disability${index}`}>
            <SwitchToggle
              className="takaful--beneficiary-update-switch"
              switchState={isHandicapped}
              onSwitchChange={(c) => updateDisablityCheck(c)}
              label="هل يعاني من إعاقة جسدية؟"
            />
          </Form.Item>
        </Col>
      </Row>

      <Form form={formDisabilities} layout="vertical">
        <Row gutter={16} style={{ marginBottom: "1rem" }}>
          {disabilities.length > 0 &&
            disabilities.map((el, index) => (
              <>
                <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    name={`disability_type_id${index}`}
                    label="نوع الإعاقة"
                    rules={[
                      {
                        required: true,
                        message: "الرجاء تعبئة الحقل",
                      },
                    ]}
                    labelCol={{ className: "takaful--label-style" }}
                  >
                    <Selects
                      options={disabilityTypes}
                      onChange={(e) => onChange(e, "disability_type_id", index)}
                    />
                  </Form.Item>
                </Col>

                <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    name={`disability_status${index}`}
                    label="حالة الإعاقة"
                    labelCol={{ className: "takaful--label-style" }}
                  >
                    <Inputs
                      type="text"
                      onChange={(e) =>
                        onChange(e.target.value, "disability_status", index)
                      }
                    />
                  </Form.Item>
                </Col>

                <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    name={`disability_cause${index}`}
                    label="سبب الإعاقة"
                    labelCol={{ className: "takaful--label-style" }}
                  >
                    <Inputs
                      type="text"
                      onChange={(e) =>
                        onChange(e.target.value, "disability_cause", index)
                      }
                    />
                  </Form.Item>
                </Col>

                <Col xxl={4} xl={4} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    name={`attachment_ids${index}`}
                    label="مرفقات"
                    labelCol={{ className: "takaful--label-style" }}
                  >
                    <UploadInput
                      accept="*"
                      text="مرفقات"
                      icon={<UploadOutlined />}
                      multiple={false}
                      maxCount={1}
                      onChange={(fileList) => handleFileChange(fileList, index)}
                      list={el.fileList}
                    />
                  </Form.Item>
                </Col>
                <Col xxl={1} xl={1} lg={4} md={4} sm={4} xs={4}>
                  {disabilities.length > 1 && (
                    <Form.Item
                      name={`remove${index}`}
                      label=" "
                      labelCol={{ className: "takaful--label-style" }}
                    >
                      <PrimaryButton
                        title=""
                        icon={<DeleteOutlined />}
                        onClick={() => removeItem(index)}
                      />
                    </Form.Item>
                  )}
                </Col>
              </>
            ))}
        </Row>
      </Form>
      {disabilities.length > 0 && (
        <div className="takaful--button-material">
          <PrimaryButton
            title="إضافة بند"
            icon={<PlusCircleOutlined />}
            onClick={() => addDisability()}
            className="takaful--primary-button-info"
          />
        </div>
      )}
      <div className="takaful--title-tabs-sub" style={{ marginTop: "10px" }}>
        <span>الإعاقة البصرية</span>
      </div>
      <Row gutter={16}>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`familiarity_with_mobile${index}`}
            label="هل لديه إلمام بإستخدام الجوال"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Selects options={reponseQuestion} />
          </Form.Item>
        </Col>

        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`proficient_in_braille${index}`}
            label="متمكن من البرايل"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Selects options={reponseQuestion} />
          </Form.Item>
        </Col>

        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`proficient_in_computing${index}`}
            label="متمكن من الحساب الآلي"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Selects options={reponseQuestion} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default OrphanHealthStatus;
